import React, { useEffect, useState } from 'react';
import { FileText, Loader2, Download } from 'lucide-react';
import { plansApi, downloadBlob, GHOST, CARD } from './shared';

export const PdfViewer = ({ planId, deck, height = 640 }) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    if (!deck?.file_id) return undefined;
    let u;
    setUrl(null); setErr(false);
    plansApi.blob(`/${planId}/pitch-deck`).then((b) => { u = URL.createObjectURL(new Blob([b], { type: 'application/pdf' })); setUrl(u); }).catch(() => setErr(true));
    return () => u && URL.revokeObjectURL(u);
  }, [planId, deck?.file_id]);

  if (!deck?.file_id) return <div className={`${CARD} p-8 text-center text-sm text-[#6B6B6B]`} data-testid="pdf-viewer-empty"><FileText className="mx-auto mb-2 text-[#A1A1AA]" size={22} />No pitch deck uploaded yet.</div>;
  return (
    <div className={`${CARD} overflow-hidden`} data-testid="pdf-viewer">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-black/[0.06] dark:border-white/5">
        <span className="text-sm font-medium text-[#0F0F0F] dark:text-white inline-flex items-center gap-2 truncate"><FileText size={14} className="text-[#FF451A]" /> {deck.filename}</span>
        {url && <button onClick={() => fetch(url).then((r) => r.blob()).then((b) => downloadBlob(b, deck.filename || 'pitch-deck.pdf'))} className={GHOST} data-testid="pdf-download-btn"><Download size={12} /> Download</button>}
      </div>
      {err ? <div className="p-8 text-center text-sm text-red-500">Could not load the pitch deck.</div>
        : !url ? <div className="flex items-center justify-center" style={{ height }}><Loader2 className="animate-spin text-[#FF451A]" size={18} /></div>
          : <><iframe title="Pitch deck" src={url} className="w-full bg-[#F4F4F5]" style={{ height }} data-testid="pdf-iframe" />
            <div className="px-4 py-2 text-xs text-[#6B6B6B] border-t border-black/[0.06]">Preview not showing? <a href={url} target="_blank" rel="noreferrer" className="text-[#FF451A] font-semibold" data-testid="pdf-open-new-tab">Open in a new tab</a></div></>}
    </div>
  );
};
